const getPrescriberPhone3 = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber.Phone) {
    return prescriber.Phone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(6, 10);
  }
  if (patient.Prescriber[0] && patient.Prescriber[0].Phone) {
    return patient.Prescriber[0].Phone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(6, 10);
  }
  return null;
};

export default getPrescriberPhone3;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberPhone3.js